import { UnitOfMeasure } from '@app/products/unit-of-measure.model';

export class TicketProduct {
  aggDeliveryChargeTypeId: number;
  object: string;
  price: number;
  productDescription: string;
  productId: number;
  productNumber: string;
  productTypeId: number;
  quantity: number;
  slump: number;
  taxableFlag: boolean;
  ticketId: number;
  unusedQuantity: number;
  unitOfMeasure: UnitOfMeasure;

  constructor() {
    this.object = 'ticketProduct';
  }
}
